<template>
  <div class="hint popup-modal">
    <div class="hint-close popup-modal_close">
        <button @click="$modal.hide('hint')"><i class="icon-cancel"></i></button>
    </div>
    <div class="popup-modal_title">{{ texts.shipmentTypeModalTitle }}</div>
    <div v-if="!isLoad">
      <div class="sending popup-modal_tabs_wrapper">
        <div class="sending-tabs popup-modal_tabs">
          <button
              v-for="tab in tabs"
              :key="tab.name"
              :class="['tab-button popup-modal_tab', currentTab &&
                        (tab.pieceType === currentTab.pieceType ? 'active' : '')]"
              @click="currentTab = tab"
          >
            {{ tab.name | t }}
          </button>
        </div>
        <div class="popup-modal_tab-content">
          <ul v-for="(item, index) in currentTab.items" :key="index">
            <li>{{ item.CommodityName }}</li>
          </ul>
        </div>
      </div>
    </div>
    <spinner over v-if="isLoad"></spinner>
  </div>
</template>

<script>
import { spinner } from '@/components/core';

export default {
  name: 'piece-hint',
  components: {
    spinner,
  },
  data() {
    return {
      isLoad: true,
      tabs: [
        {
          name: 'ShipmentTypeModalDocuments',
          pieceType: 0,
          items: [],
        },
        {
          name: 'ShipmentTypeModalNonDocuments',
          pieceType: 1,
          items: [],
        },
      ],
      currentTab: null,
    };
  },
  mounted() {
    this.onGetTaxGoods();
  },
  computed: {
    texts() {
      return {
        shipmentTypeModalTitle: this.$t('ShipmentTypeModalTitle'),
      };
    },
  },
  methods: {
    onGetTaxGoods() {
      this.isLoad = true;
      this.$api.getSalTaxGoods().then((result) => {
        this.tabs[0].items = result.Docs;
        this.tabs[1].items = result.Goods;

        [this.currentTab] = this.tabs;
        this.isLoad = false;
      });
    },
  },
};
</script>

<style scoped>
  .hint {
    min-height: 200px;
  }
  .popup-modal {
    display: block;
  }
</style>
